import axios from "axios"

const CALENDAR_SUMMARY_PATH = '/api/planner/calendar-summary'
const DAILY_COMBINATIONS_PATH = '/api/planner/daily-combinations'


export async function getCalendarAvailablePlanCounts({
  month,
  tourSize,
  selectedShopIds,
  fixedShopIds,
}) {
  return axios.post(
    `${CALENDAR_SUMMARY_PATH}`,
    {
      month,
      tourSize,
      selectedShopIds,
      fixedShopIds,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 30000,
    }
  ).then(res => res.data)
}

export async function getDailyAvailableCombinations({
  date,
  tourSize,
  selectedShopIds,
  fixedShopIds,
}) {
  return axios.post(
    `${DAILY_COMBINATIONS_PATH}`,
    {
      date,
      tourSize,
      selectedShopIds,
      fixedShopIds,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      timeout: 30000,
    }
  ).then(res => res.data)
}

export async function bookCombination ({
  slots,
  customerName,
  // customerPhone,
  weddingDate,
  weddingDateUndecided,
  noShooting,
  shootingDate,
  shootingDateUndecided,
  notice,
}) {
  return axios.post('/api/planner/book', {
    slots,
    customerName,
    // customerPhone,
    weddingDate,
    weddingDateUndecided,
    noShooting,
    shootingDate,
    shootingDateUndecided,
    notice,
  }, {
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 30000,
  }).then(res => res.data)
}

export const cancelReservation = ({ reservationCode, cancelReason }) => {
  return axios.post('/api/planner/cancel-book', {
    reservationCode,
    cancelReason
  })
    .then(res => res.data)
}

export const changeCustomerName = ({ reservationCode, newCustomerName }) => {
  return axios.put(`/api/planner/reservations/${reservationCode}/customer-name`, {
    customerName: newCustomerName
  })
    .then(res => res.data)
}


export async function fetchPreviewDataBySlotIds(params) {
  return axios.get('/api/planner/preview', {
    params,
    headers: {
      'Content-Type': 'application/json',
    },
    timeout: 30000,
  }).then(res => res.data)
}